import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPlaying } from "../../../redux/slices/canvas";
import { selectLayer, setSelectedLayers } from "../../../redux/slices/project";
import { RootState } from "../../../redux/store";
import { Layer, ProjectState } from "../../../shared";

type FrameOverlayProps = {
    layer: Layer;
}

function FrameOverlay({ layer }: FrameOverlayProps) {
    const frame = useSelector((state: RootState) => state.canvas.frame);
    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                display: 'flex',
                width: layer.dimensions.width,
                height: layer.dimensions.height,
                boxSizing: 'border-box',
                border: frame === layer.startFrame ? '4px solid black' : ''
            }}>
        </div>
    )
}


type FrameProps = {
    project: ProjectState;
    layer: Layer;
}

function Frame({ layer }: FrameProps) {
    const dispatch = useDispatch();

    const onClickLayer = (layer: Layer) => {
        dispatch(setPlaying(false));
        dispatch(setSelectedLayers({}));
        dispatch(selectLayer(layer.index));
    }

    return (
        <div
            style={{
                position: 'relative',
                display: 'flex',
                width: layer.dimensions.width,
                backgroundColor: 'lightgray',
                boxSizing: 'border-box',
            }}
            onClick={() => onClickLayer(layer)}>
            <img 
                src={layer.url}
                alt={layer.name}
                width={layer.dimensions.width}
                height={layer.dimensions.height}
                style={{
                    width: layer.dimensions.width,
                    height: layer.dimensions.height,
                    boxSizing: 'border-box',
                }}
            />
            <FrameOverlay
                layer={layer} />
        </div>
    )
}

type Props = {
    project: ProjectState
}

function FilmStrip({ project }: Props) {
    console.log('rerender FilmStrip');
    const imageLayers = project.layers.filter(l => l.type === "image");

    return (
        <div
            style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                backgroundColor: 'black',
                color: 'white',
                width: '100%',
                height: '100%',
                overflow: 'scroll'
            }}>
                {imageLayers.map((layer) => {
                    return (
                        <Frame 
                            key={layer.id}
                            project={project} 
                            layer={layer} />
                    )
                })}
        </div>
    );
}

export default FilmStrip;